import { gql } from '__generated__';

export default gql(`
  mutation EditLottery($input: EditLotteryInput!) {
    editLottery(input: $input) {
      ...LotteryAttributes
    }
  }
`);
